import { Component, Input, OnInit, Output, EventEmitter, ViewChild, HostListener, ElementRef, TemplateRef, ContentChild, Directive, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import {
  GridDataService, FilterService, GridSortService, ColumnDefinitionsModel, GridTableOptionsModel,
  PaginationsModel, FetchCriteriaModel
} from './shared';
import { RowDoubleClickedEvent, CellDoubleClickedEvent, RowClassParams } from 'ag-grid-community';

@Directive({selector: '[cell]'})
export class Cell {
  @Input() id!: string;
}

@Component({
  selector: 'app-custom-grid-table',
  providers: [FilterService, GridSortService, GridDataService],
  templateUrl: './custom-grid-table.component.html',
  styleUrls: ['./custom-grid-table.component.scss']
})
export class CustomGridTableComponent implements OnInit, AfterContentInit {

  startIndex: number = 0;
  searchPlaceHolder: string = 'Enter first or last name';
  ctnMask: boolean = false;
  searchDescriptions: string = '';
  gridProperties: GridTableOptionsModel;
  showBackLink: boolean;
  isGridValid: boolean;
  filteredColumns = [];
  gridData: any;
  filteredData: any;
  //multipleSelectedItems = [];
  //singleSelectedItems = [];
  paginations: PaginationsModel;
  sortColumn: string = "";
  sortDirection: string = "";
  searchValue: string = "";
  showhigherpriorities: number = 0;
  allRowsSelected: boolean = false;
  maxPriority: number = 0;
  showTable: boolean;
  enableSearchLimit: boolean = false;
  searchLimit: number = 3;
  searchMessage: string = "";
  ctnNumbertoFormate: FormControl;
  maxLength: number;
  numericSearch: boolean;
  ariaLabel: string;
  sortAriaLabel: string;
  changeSortOrderAriaLabel: string;
  searchLabel: string;
  sortHeadAria: string;
  hideSortHeadRead: boolean;
  isCopied: boolean = false;


  @ViewChild('searchValue') searchFan;

  @Input() mainAriaLAbel :  any;

  @Input() set filterValue(searchValue) {
    this.filter(searchValue);
  } 
  @Input() set gridOptions(options: GridTableOptionsModel) {
    if (options == undefined) {
      this.isGridValid = false;
      return;
    }
    this.isGridValid = true;
    this.gridProperties = options;
    this.paginations = options.Paginations;
    this.searchPlaceHolder = options.searchPlaceHolder === undefined ? this.searchPlaceHolder : options.searchPlaceHolder;
    this.ctnMask = options.ctnMask === undefined ? this.ctnMask : options.ctnMask;
    this.searchDescriptions = options.searchDescriptions;
    this.showTable = options.showGrid;
    this.enableSearchLimit = options.enableSearchLimit;
    this.searchLimit = options.searchLimit;
    this.maxLength = options.maxLength;
    this.ariaLabel = options.ariaLabel?options.ariaLabel:this.mainAriaLAbel;
    if (options.searchType === 'number') {
      this.numericSearch = true;
    };
    this.gridProperties.columnDefinitions.forEach(r => {
      r['priority'] = r['priority'] === undefined ? 1 : r['priority'];
      if (this.maxPriority < r['priority']) {
        this.maxPriority = r['priority'];
      }
    });

    if (this.paginations.currentPage == 1) {
      this.startIndex = 0;
    }
    //this.getApplicableFilterCols();
    if (this.gridProperties.multiSelect) {
      this.gridData = this.setDefault(options.gridData);
    }
    if (this.paginations.isServerSide) {
      this.gridData = options.gridData
    } else {
      this.setGridData(options.gridData);
    }
    this.checkAllRowsSelected();
  }

  @ContentChildren(TemplateRef) contentChildrenList: QueryList<TemplateRef<any>>;
  contentChildren: TemplateRef<any>[];
  @ContentChild('header',{read: false}) templateRef: TemplateRef<any>;
  
  @ViewChild('gridcontainer') gridcontainer;
  @Output() hrefLink: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkboxSelections: EventEmitter<any> = new EventEmitter<any>();
  @Output() radioSelections: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();

  @Output() onDataChange: EventEmitter<any> = new EventEmitter<any>();
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setPriorityData();
  }


  @Output() gridEvent: EventEmitter<FetchCriteriaModel> = new EventEmitter<FetchCriteriaModel>();



  constructor(private el: ElementRef,
    private filterService: FilterService,
    private gridSortService: GridSortService,
    private router: Router) {
    this.ctnNumbertoFormate = new FormControl();
  }
  // getData() {

  //   console.log('Service getData');
  //   this.gridService.fetchGridData(this.utilityService.getEnvConfig().mockGridDataUrl).
  //     subscribe(respobj => {
  //       console.log(respobj);
  //       if (respobj != null && respobj != undefined) {
  //         this.filteredData = this.filteredData.concat(respobj);
  //         this.totalRecords = this.filteredData.length;
  //       }
  //     }, error => {
  //       console.log(error);
  //     });
  // }

  linkAction(currentData, column) {
    currentData = Object.assign({}, currentData, { 'selectedColumn': column });
    this.hrefLink.emit(currentData);
  }
  ngOnInit() {
    this.setPriorityData();
    // if (!this.ariaLabel) {
    //   this.ariaLabel = 'Enter first or last name';
    // }
  }
  ngAfterContentInit() {
    this.contentChildren = this.contentChildrenList.toArray();
  }

  onPageChange(startIndex) {
    this.startIndex = startIndex;
    this.paginations.currentPage = (startIndex / this.paginations.recordsPerPage) + 1;
    if (this.paginations.isServerSide) {
      this.getServerData();
    }
    else {
      this.getPageData(this.paginations.currentPage);
    }
    this.checkAllRowsSelected();
    // const focusableEls = this.el.nativeElement.getElementsByTagName('table')[0].querySelectorAll('a[href], area[href],' +
    //   ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    // if (focusableEls.length) {
    //   focusableEls[0].focus();
    // }
    const focusableEls = this.el.nativeElement.querySelectorAll('#totalCount');
    if (focusableEls.length) {
      setTimeout(() => { focusableEls[0].focus(); });
    }
  }



  setGridData(data: any) {
    this.filteredData = data;
    this.getPageData(this.paginations.currentPage);
  }


  // getApplicableFilterCols() {
  //   this.filteredColumns = [];
  //   if (this.gridProperties.enableFiltering) {
  //     for (let cols of this.gridProperties.columnDefinitions) {
  //       if (cols.enableFilter) {
  //         this.filteredColumns.push(cols.field);
  //         if(cols.secondaryField) {
  //           this.filteredColumns.push(cols.secondaryField);
  //         }
  //       }
  //     }
  //   }
  // }

  getPageData(pageNo: number) {

    let endIndex: number = 0;
    this.paginations.currentPage = pageNo - 1;
    endIndex = (this.startIndex + this.paginations.recordsPerPage);
    let data = this.filteredData;
    this.gridData = data.slice(this.startIndex, endIndex);
    // if (endIndex + (this.paginations.recordsPerPage * 2) > this.totalRecords) {
    //   this.getData();
    // }

    //for server side pagination : need to pass start-index & limit
    // bind the data directly to gridData


  }

  singleSelectionChanges(ctrl) {
    this.radioSelections.emit(ctrl);
    // this.singleSelectedItems = [];
    // this.singleSelectedItems.push(ctrl);
  }

  selectionChanges(ctrl, event) {

    ctrl = Object.assign({}, ctrl, { 'checkedStatus': event.target.checked });

    this.checkboxSelections.emit(ctrl);

    // if (event.target.checked) {
    //   this.multipleSelectedItems.push(ctrl);
    // }

    // else {
    //   if (this.multipleSelectedItems.find(x => x == ctrl)) {
    //     this.multipleSelectedItems.splice(this.multipleSelectedItems.indexOf(ctrl), 1)
    //   }
    // }
  }
  
  filter(searchValue: string, clearSearch?: boolean, linkType?: string) {
    let filteredData: any;
    searchValue = searchValue.trim();
    if (this.enableSearchLimit &&
      (searchValue.length > 0 && searchValue.length < this.searchLimit)) {
      this.searchMessage = "Enter atleast " + this.searchLimit + " characters to search"
      this.searchFan.nativeElement.focus();
      return;
    }

    if (this.enableSearchLimit && searchValue.toString().substring(0, 3).indexOf(' ') >= 0) {
      this.searchMessage = 'Enter valid characters to search';
      this.searchFan.nativeElement.focus();
      return;
    }

    this.searchMessage = "";
    if (this.ctnMask) {
      searchValue = searchValue.split('.').join('');
    }
    else {
      searchValue = searchValue;
    }
    this.startIndex = 0;
    this.searchValue = searchValue;
    this.paginations.currentPage = 1;
    if (this.paginations.isServerSide) {
      this.getServerData();
      this.showBackLink = true;
    } else {
      filteredData = this.filterService.getFilteredData(
        this.gridProperties.gridData, searchValue, this.filteredColumns);
      this.paginations.totalRecords = filteredData.length;
      this.setGridData(filteredData);
      this.showBackLink = true;
    }
    if (clearSearch || !searchValue) {
      this.searchFan.nativeElement.value = '';
      this.showBackLink = false;
    } else {
      this.showBackLink = true;
    }
    this.checkAllRowsSelected();
    const searchCleared = clearSearch || !searchValue;
    if (!this.gridProperties.showGrid) {
      this.showTable = searchCleared ? false : true;
    }
    if (linkType === 'viewAllLink' && this.gridProperties.showGrid === false) {
      this.showTable = true;
      this.gridProperties.showGrid = true;
    }
    this.onSearch.emit({ 'search': searchCleared, 'results': filteredData });
    //window.dispatchEvent(new Event('resize'));
  }

  getServerData() {

    let fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();

    fetchCriteria.limit = this.paginations.recordsPerPage;
    fetchCriteria.offset = this.startIndex;

    if (this.sortColumn.length > 0) {
      fetchCriteria.sortField = this.sortColumn;
    }

    if (this.sortDirection.length > 0) {
      fetchCriteria.sortDir = this.sortDirection.toUpperCase();
    }

    if (this.searchValue.length > 0) {
      fetchCriteria.searchValue = this.searchValue;
    }

    this.gridEvent.emit(fetchCriteria);


    // let fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();

    // fetchCriteria.class = "API::SepPagingLoadConfig";
    // fetchCriteria.limit = this.paginations.recordsPerPage;
    // fetchCriteria.offset = this.startIndex;
    // fetchCriteria.sortDir = this.sortDirection.toUpperCase();
    // fetchCriteria.sortField = this.sortColumn;

    // this.gridProperties.gridFetch.fetchCriteria = fetchCriteria;

    // if (this.searchValue.length > 0) {
    //   this.gridProperties.gridFetch.searchValue = this.searchValue;
    // }

    // console.log('Service getData');
    // this.gridService.fetchGridServiceData(this.gridProperties.dataUrl, this.gridProperties.gridFetch).
    //   subscribe(respobj => {
    //     console.log(respobj);
    //     if (respobj != null && respobj != undefined) {
    //       if (isPageChanges) {
    //         this.gridData = respobj;
    //       }
    //       else {
    //         this.setGridData(respobj);
    //         this.paginations.totalRecords = respobj.length;
    //       }
    //     }
    //   }, error => {
    //     console.log(error);
    //   });
  }

  // handleSort( col: ColumnDefinitionsModel){
  //   this.sortHeadAria = col.sortDirection === 'Asc'? 'Sort descending - '+col.caption : 'Sort ascending - '+col.caption;
  //   console.log( this.sortHeadAria );
  //   return this.sortHeadAria;
  // }

  handleHeadingFocus( ){
    this.ariaLabel = this.gridProperties.ariaLabel? this.gridProperties.ariaLabel: this.mainAriaLAbel;
  }

  handleHeadingBlur( ){
    this.ariaLabel = null;
  }

  handleSortBlur(  ){ 
      this.hideSortHeadRead = true;
  }

  handleSortFocus(  ){
      this.hideSortHeadRead = false;
  }


  // sort(col: ColumnDefinitionsModel) {
  //   this.sortColumn = col.field;
  //   this.sortDirection = (!!col.sortDirection && col.sortDirection !== 'Default') ? col.sortDirection : 'Desc';
  //   this.paginations.currentPage = 1;
  //   this.startIndex = 0;
  //   this.sortDirection = (this.sortDirection.toLowerCase() == 'asc') ? 'Desc' : 'Asc';
  //   if (this.paginations.isServerSide) {
  //     this.getServerData();
  //   }
  //   else {
  //     let sortedData = this.gridSortService.getSortedData(
  //       this.filteredData, this.sortColumn, this.sortDirection);
  //     //this.paginations.currentPage = this.paginations.currentPage + 1;
  //     this.setGridData(sortedData);
  //   }

  //   col.sortDirection = this.sortDirection;
  //   this.checkAllRowsSelected();
  // }

  multiSelectAction(event) {
    const checkStatus = event.target.checked;
    this.gridData.forEach(r => {
      if (!this.gridProperties.disableRow ||
      (this.gridProperties.disableRow && this.gridProperties.disableRowConditionInverse &&
      r[this.gridProperties.disableRowCondition.field] === this.gridProperties.disableRowCondition.value) ||
      (this.gridProperties.disableRow && !this.gridProperties.disableRowConditionInverse &&
      r[this.gridProperties.disableRowCondition.field] !== this.gridProperties.disableRowCondition.value)
      ) {
        r['selected'] = checkStatus;
      }
    });
    this.onDataChange.emit({ data: this.gridProperties.gridData, griddata: this.filteredData, type: 'multiselect' });
    this.checkAllRowsSelected();
  }

  setDefault(gridData) {
    return gridData.forEach(r => r['selected'] = r['selected'] === undefined ? false : r['selected']);
  }

  checkAllRowsSelected() {
    const selectedRow = this.gridData.filter(item => item.selected === true);
    const activeRow = this.gridData.filter(item => !this.gridProperties.disableRow ||
    (this.gridProperties.disableRow && this.gridProperties.disableRowConditionInverse &&
      item[this.gridProperties.disableRowCondition.field] === this.gridProperties.disableRowCondition.value) ||
      (this.gridProperties.disableRow && !this.gridProperties.disableRowConditionInverse &&
      item[this.gridProperties.disableRowCondition.field] !== this.gridProperties.disableRowCondition.value));
    this.allRowsSelected = activeRow.length === selectedRow.length;
  }

  singleSelectAction(col: ColumnDefinitionsModel, event) {
    const checkStatus = event.target.checked;
    col['selected'] = checkStatus;
    this.onDataChange.emit({ data: col, griddata: this.filteredData, type: 'singleselect' });
    this.checkAllRowsSelected();
  }

  setPriorityData() {
    if (window.innerWidth < 767) {
      this.showhigherpriorities = 2;
    }
    else if (window.innerWidth < 1000) {
      this.showhigherpriorities = 4;
    }
    else {
      this.showhigherpriorities = 6;
    }
  }

}

